import { Link } from 'react-router-dom';
import { SiteMeta } from '@/components/site/SiteMeta';
import { usePlansCatalog } from '@/context/PlansContext';
import { guides } from '@/content/guides';
import { checkoutPath, cheapestPaidPlanPriceCents, effectivePlanPriceCents, formatPlanPrice } from '@/content/plans';
import { sectors } from '@/content/sectors';
import { buyablePlans } from '@/lib/calculator';
import { supportWhatsAppHref } from '@/lib/supportChat';
import { ClientsStrip } from '@/pages/site/home/ClientsStrip';
import { HomeFaq } from '@/pages/site/home/HomeFaq';
import { HomeHow } from '@/pages/site/home/HomeHow';
import { HomeHero } from '@/pages/site/home/HomeHero';
import { HomePricing } from '@/pages/site/home/HomePricing';
import { PlanBuilder } from '@/pages/site/home/PlanBuilder';
import { useCatalogApps } from '@/pages/site/home/useCatalogApps';

/** Fallback alinhado ao plano Start do catálogo: evita traço se a API falhar. */
const FROM_PRICE_FALLBACK_CENTS = 12990;

export function HomePageSite() {
  const { plans, sortedPlans } = usePlansCatalog();
  const apps = useCatalogApps();
  const appsCount = apps.length;
  const freeApps = apps.filter((a) => a.tier === 'included').length;
  const cents = cheapestPaidPlanPriceCents(plans) ?? FROM_PRICE_FALLBACK_CENTS;
  const fromPrice = formatPlanPrice(cents);
  const topCents = Math.max(...buyablePlans(sortedPlans).map(effectivePlanPriceCents), cents);

  return (
    <>
      <SiteMeta
        title="Operax - Todo o atendimento ao cliente, numa plataforma só"
        description={`Plataforma de atendimento no WhatsApp oficial da Meta: conversas, funil, agenda e apps no mesmo login. A partir de ${fromPrice}/mês.`}
        path="/"
      />
      <HomeHero appsCount={appsCount} fromPrice={fromPrice} />
      <ClientsStrip />
      <PlanBuilder apps={apps} />

      <HomeHow />
      <HomePricing freeApps={freeApps} />

      <section className="hx-sec" style={{ paddingTop: 0 }}>
        <div className="hx-wrap">
          <div className="hx-explore">
            <div className="rev">
              <h3>Para o seu negócio</h3>
              <ul className="hx-chips">
                {sectors.map((s) => (
                  <li key={s.slug}>
                    <Link to={`/setores/${s.slug}`}>{s.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="rev">
              <h3>Antes de assinar, entenda o WhatsApp oficial</h3>
              <ul className="hx-chips">
                {guides.map((g) => (
                  <li key={g.slug}>
                    <Link to={`/guias/${g.slug}`}>{g.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <HomeFaq
        appsCount={appsCount}
        sectorsCount={sectors.length}
        fromPrice={fromPrice}
        topPrice={formatPlanPrice(topCents)}
      />

      <section className="hx-final">
        <div className="hx-final-in">
          <h2>Comece com o núcleo hoje. Ative apps quando a operação pedir.</h2>
          <div className="hx-actions">
            <Link className="btn hx-btn-main" to={checkoutPath}>
              Assinar agora
            </Link>
            <a className="btn hx-btn-line" href={supportWhatsAppHref()}>
              Tirar dúvida no WhatsApp
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
